var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-flex", { attrs: { xs12: "", sm6: "", md6: "" } }, [
    _c(
      "div",
      { attrs: { align: "left" } },
      [
        _c("v-text-field", {
          attrs: {
            "append-icon": "search",
            label: "Buscar...",
            "single-line": "",
            "hide-details": ""
          },
          on: { input: _vm.onFilterTextBoxChanged },
          model: {
            value: _vm.search,
            callback: function($$v) {
              _vm.search = $$v
            },
            expression: "search"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }